module.exports = __webpack_public_path__ + "img/kitchen.e8056e58.png";